module.exports = __webpack_public_path__ + "fonts/EMprint-Regular.e63e726a.ttf";